const getters = {
  sidebar: (state) => state.app.sidebar,
  user: (state) => state.user.user || {},
  menuList: (state) => state.app.menuList,
};
export default getters;
